<template>
  <div class="my-3 d-flex flex-column justify-content-center">
    <div class="pe-5">
      <div class="d-flex me-3 col-12">
        <div class="d-flex align-items-start">
          <div class="mx-3 d-flex align-items-center">
            <el-switch
              v-model="isDisplay"
              :disabled="sortMode"
              :active-value="$defines.Part_Is_Display_Yes"
              :inactive-value="$defines.Part_Is_Display_No"
              @change="emitNewList"
            />
          </div>
          <!-- <img
          class="mx-3 opacity-0"
          src="@/assets/icons/arrow-blue.svg"
          alt=""
        /> -->
          <div class="bg-primary list-id me-3 position-relative">
            {{ $attrs.qIndex }}
            <!-- <span v-if="showRequired" class="text-danger position-absolute top-0"
            >*</span
          > -->
          </div>
        </div>
        <div class="title-wrapper px-2 my-2">
          <textarea
            rows="4"
            oninput='this.style.height = ""; this.style.height = this.scrollHeight + "px"'
           type="text"
            placeholder="標題"
            :disabled="sortMode"
            v-model="inputTitle"
            @click="closeBtnList = false"
            class="title"
            @input="emitNewList"
          />
        </div>
        <div class="function-img my-2 d-flex align-items-start pb-2">
          <img
            @click="closeBtnList = false"
            v-if="closeBtnList"
            src="@/assets/icons/edit.svg"
            alt=""
          />
          <img
            @click="$emit('copyItem', [element, $attrs.qIndex])"
            src="@/assets/icons/list-copy.svg"
            class="mx-3"
            alt=""
            v-c-popover="{
              content: '複製',
              placement: 'top',
              trigger: 'hover',
            }"
          />

          <img
            @click="$emit('deleteItem', element)"
            src="@/assets/icons/delete.svg"
            :class="sortMode ? 'me-3' : ''"
            v-c-popover="{
              content: '刪除',
              placement: 'top',
              trigger: 'hover',
              visible: false,
            }"
            alt=""
          />
          <img
            v-if="sortMode"
            src="@/assets/icons/list-sort.svg"
            class="me-3 handle"
            v-c-popover="{
              content: '拖曳',
              placement: 'top',
              trigger: 'hover',
            }"
            alt=""
          />
        </div>
      </div>
      <div class="col-12 d-flex justify-content-end flex-column">
        <div class="d-flex">
          <div class="col-2"></div>
          <textarea
            oninput='this.style.height = ""; this.style.height = this.scrollHeight + "px"'
            v-if="showRemark"
            type="text"
            placeholder="備註說明"
            class="px-2 my-2 col-10 remark ms-auto"
            @click="closeBtnList = false"
            @input="emitNewList"
            v-model="remark"
          />
        </div>
        <div v-if="!closeBtnList" class="col-12 d-flex">
          <div class="col-2"></div>
          <!-- <button
          class="rounded p-1 mt-2 btn remark-btn"
          :class="showRequired ? 'btn-primary' : 'btn-secondary'"
          @click=";(showRequired = !showRequired), emitNewList()"
        >
          必填
        </button> -->
          <button
            class="rounded p-1 mt-2 mx-2 btn remark-btn"
            :class="showRemark ? 'btn-primary' : 'btn-secondary'"
            @click="useRemark"
          >
            備註
          </button>
          <button
            class="rounded p-1 mt-2 btn remark-btn"
            :class="showPhoto ? 'btn-primary' : 'btn-secondary'"
            @click="showPhoto = !showPhoto"
            v-c-popover="{
              content: '點擊編輯或移除圖片',
              placement: 'bottom',
              trigger: 'hover',
            }"
          >
            多媒體上傳
          </button>
          <CropPicture
            :show="showPhoto"
            @close=";(showPhoto = false), emitNewList()"
            @image="image = $event"
          />
        </div>
      </div>
      <div class="col-12 d-flex mb-3">
        <div class="col-2"></div>
        <div class="col-8">
          <div class="edit-img">
            <CImage
              v-if="image"
              rounded
              thumbnail
              :src="image"
              width="200"
              height="200"
              class="mt-3"
            />
            <img
              v-if="image"
              @click="clearImg"
              class="delete-img"
              src="@/assets/icons/delete-img.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!closeBtnList"
      class="d-flex align-items-center justify-content-between col-12 p-3 close-btn-group"
    >
      <div
        class="d-flex col-3 align-items-center justify-content-between type-text-wrapper"
      >
        <span>題項類型：</span>
        <div class="type-text">引言</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import CropPicture from '@/components/CropPicture.vue'
import { SAVE_ACTION_UPDATE } from '../defines'
export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    sortMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['newList', 'deleteItem', 'copyItem'],
  components: {
    CropPicture,
  },
  setup(props, { emit }) {
    const showRemark = ref(false)
    // const showRequired = ref(false)
    const showPhoto = ref(false)
    const closeBtnList = ref(false)
    const inputTitle = ref(props.element.title)
    const remark = ref(props.element.description)
    const image = ref(props.element.image)
    const isDisplay = ref(props.element.is_display)
    const showDelete = ref(true)
    const useRemark = () => {
      showRemark.value = !showRemark.value
      // if (!showRemark.value) {
      //   remark.value = ''
      // }
      emitNewList()
    }
    const clearImg = () => {
      image.value = ''
      emitNewList()
    }
    const emitNewList = () => {
      emit('newList', {
        part_item_id: props.element.part_item_id,
        time: props.element.time,
        type: props.element.type,
        title: inputTitle.value,
        description: showRemark.value ? remark.value : '',
        is_display: isDisplay.value,
        image: image.value,
        required: '1',
        action: SAVE_ACTION_UPDATE,
        extension_info: [],
      })
    }
    // emitNewList()

    return {
      showRemark,
      closeBtnList,
      showDelete,
      // showRequired,
      inputTitle,
      remark,
      emitNewList,
      showPhoto,
      useRemark,
      clearImg,
      image,
      isDisplay,
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #9ca0a8;
  outline: none;
}
.title {
  width: 100%;
  border: 0;
  outline: none;
  resize: none;
  max-height: 90px;
}
.remark {
  border: 0;
  border-bottom: 1px solid #9ca0a8;
  outline: none;
  font-size: 13px;
  resize: none;
  max-height: 125px;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.content {
  background-color: #fff !important;
  border: 1px solid #9ca0a8;
  border-radius: 3px;
}
.list-id {
  width: 40px;
  height: 40px;
  background: #177baf;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  span {
    left: 5px;
  }
}
.function-img {
  border-bottom: 1px solid #9ca0a8;
  img {
    cursor: pointer;
  }
}
.close-btn-group {
  background: rgba(23, 123, 175, 0.1);
  border-radius: 0px 0px 20px 20px;
}
.type-text-wrapper {
  font-size: 12px;
}
.type-text {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: 16px;
  width: 98px;
}
.delete-img {
  position: absolute;
  filter: drop-shadow(0px 1px 1px #fff);
  top: 25px;
  right: 10px;
  width: 20px;
  cursor: pointer;
}
.edit-img {
  width: 200px;
  position: relative;
}
textarea:disabled{
  background-color: #fff;
}
</style>
